import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Select,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
  Hidden,
  FormHelperText,
} from '@material-ui/core'
// import { Group, Email, Message } from '@material-ui/icons'
import Button from 'components/theme/Button'
import { handleFieldChange } from 'actions/tasks'
import styles from './styles'
import { currentlyUsedTaskTypesByIDSelector } from 'selectors/tasks'
import EntityTypeIcon from 'utils/EntityTypeIcon'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'
import language from 'utils/vast-languagepack'
import { stepperDecrease } from 'actions/view'
import { list, read } from 'actions/data'
import { openSnackbar, stepperGoTo } from 'actions/view'
import { DATA_API_URL } from 'utils/AllURLs'
import ClickableTooltip from 'components/theme/ClickableTooltip'
import TooltipContent from 'components/A2P10DLC/TooltipContent'

export const SelectedActionButton = withStyles(styles)(
  ({
    selectedAction,
    actionType,
    Icon,
    handleFieldChange,
    stepperGoTo,
    stepper,
    classes,
    size,
    fullWidth,
    title,
    taskName,
    ...props
  }) => (
    <Button
      variant={selectedAction === actionType ? 'contained' : 'outlined'}
      size={size}
      onClick={() => {
        handleFieldChange('selectedActionPrediction', actionType)
        if (taskName !== '' && stepper === 0) stepperGoTo(1, 'task')
      }}
      color="secondary"
      fullWidth={fullWidth !== false}
      {...props}
    >
      {Icon}
      {title}
    </Button>
  ),
)

export default connect(
  state => ({
    selectedAction: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    taskTypes: currentlyUsedTaskTypesByIDSelector(state),
    taskName: state.tasks.addOrEdit.fields.name.value,
    stepper: state.view.stepper.task,
    default_email_from:
      state.data['account/preference'] &&
      state.data['account/preference'].preferences &&
      state.data['account/preference'].preferences.default_email_from,
    phonesLength:
      typeof state.data.phonenumbers === 'object' &&
      Object.values(state.data.phonenumbers).length,
    'email/verify_default_address_status':
      state.data['email/verify_default_address_status'] &&
      state.data['email/verify_default_address_status'].status,
    disabled: state.tasks.addOrEdit.taskID !== 'new',
    approvedCampaignExists: Object.values(
      Object.values(state.data.a2p10dlc || {})?.[0]?.campaigns || {},
    ).some(campaign => campaign?.campaignStatus?.slice?.(0, 8) === 'VERIFIED'),
    a2p10dlcLoadStatus: state.loadStatus.a2p10dlc,
  }),
  dispatch =>
    bindActionCreators(
      {
        handleFieldChange,
        stepperDecrease,
        list,
        read,
        openSnackbar,
        stepperGoTo,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class SelectedActionButtons extends Component {
      state = {
        phonesLoaded: false,
        emailStatusLoaded: false,
      }

      componentDidMount() {
        this.forceUpdate()

        this.props.read('', 'account/preference', null, 'none').then(prefs => {
          if (prefs && prefs.preferences) {
            if (prefs.preferences.default_email_from) {
              this.props
                .read('', 'email/verify_default_address_status', null, 'none')
                .then(() => this.setState({ emailStatusLoaded: true }))
            } else {
              this.setState({ emailStatusLoaded: true })
            }
          } else {
            this.setState({ emailStatusLoaded: true })
          }
        })

        this.props
          .list('phonenumbers')
          .then(() => this.setState({ phonesLoaded: true }))

        if (!this.props.a2p10dlcLoadStatus) {
          this.props.list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
        }
      }

      componentDidUpdate(prevProps, prevState) {
        const {
          selectedAction,
          phonesLength,
          openSnackbar,
          default_email_from,
        } = this.props
        const { phonesLoaded, emailStatusLoaded } = this.state

        if (
          selectedAction === 'sms' &&
          !phonesLength &&
          (prevState.phonesLoaded !== phonesLoaded ||
            prevProps.selectedAction !== selectedAction ||
            prevProps.phonesLength !== phonesLength)
        ) {
          openSnackbar({
            type: 'error',
            message: 'No phone numbers',
            actionMessage: 'Click here add a phone number',
            action: 'toggleManagePhonesModal',
          })
        }

        if (
          selectedAction === 'email' &&
          (!default_email_from ||
            this.props['email/verify_default_address_status'] !== 'success') &&
          (prevState.emailStatusLoaded !== emailStatusLoaded ||
            prevProps.selectedAction !== selectedAction ||
            prevProps.default_email_from !== default_email_from ||
            prevProps['email/verify_default_address_status'] !==
              this.props['email/verify_default_address_status'])
        ) {
          openSnackbar({
            type: 'error',
            message: 'Missing verified email',
            actionMessage: 'Click here to verify an address',
            action: 'link',
            to: '/accountsettings',
          })
        }
      }

      render() {
        const {
          select,
          selectedAction,
          handleFieldChange,
          stepperGoTo,
          classes,
          taskTypes,
          stepper,
          stepperDecrease,
          default_email_from,
          phonesLength,
          disabled,
          taskName,
        } = this.props

        // const actions = [
        //   [Email, 'email', 'Email'],
        //   [Message, 'sms', 'SMS'],
        //   [Group, 'groupAdd', 'Add To Group'],
        //   [Group, 'groupRemove', 'Remove From Group'],
        //   [Group, 'groupMove', 'Move Group'],
        // ]

        const showErrorText = () => {
          if (
            this.state.emailStatusLoaded &&
            selectedAction === 'email' &&
            (!default_email_from ||
              this.props['email/verify_default_address_status'] !== 'success')
          ) {
            return 'You need to verify an email address in account settings before sending an email'
          }

          if (
            this.state.phonesLoaded &&
            selectedAction === 'sms' &&
            !phonesLength
          ) {
            return 'You need to add a phone number before sending a text'
          }

          return false
        }

        const selectMenu = (
          <FormControl disabled={disabled} fullWidth variant="outlined">
            <InputLabel
              ref={ref => {
                this.labelRef = ReactDOM.findDOMNode(ref)
              }}
              htmlFor="taskSelectedActionSelect"
              shrink
              style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
            >
              {language.task.add.selectTaskType}
            </InputLabel>
            <Select
              value={selectedAction}
              onChange={e => {
                if (
                  selectedAction === 'email' &&
                  e.target.value !== 'email' &&
                  stepper === 3
                ) {
                  stepperDecrease('task')
                }

                handleFieldChange('selectedActionPrediction', e.target.value)
                if (taskName !== '' && stepper === 0) stepperGoTo(1, 'task')
              }}
              input={
                <OutlinedInput
                  notched
                  labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                  id="taskSelectedActionSelect"
                  classes={{ notchedOutline: classes.notchedOutline }}
                />
              }
            >
              {Object.values(taskTypes).map(taskType => {
                const a2p10dlcDisabled =
                  taskType.name === 'trigger.cmd.send.sms' &&
                  !this.props.approvedCampaignExists

                const menuItem = (
                  <MenuItem
                    disabled={
                      taskType.name === 'trigger.cmd.send.sms' &&
                      !this.props.approvedCampaignExists
                    }
                    key={`taskSelectFieldValue${taskType.id}`}
                    value={
                      taskTypeIDToNameMap?.[taskType.id]?.name || 'Unknown'
                    }
                  >
                    {taskType.display_name}
                  </MenuItem>
                )

                return a2p10dlcDisabled ? (
                  <ClickableTooltip
                    content={<TooltipContent />}
                    key={`taskSelectFieldValue${taskType.id}-tooltip`}
                  >
                    {menuItem}
                  </ClickableTooltip>
                ) : (
                  menuItem
                )
              })}
            </Select>
            {showErrorText() && (
              <FormHelperText error>{showErrorText()}</FormHelperText>
            )}
          </FormControl>
        )

        return disabled ? null : select ? (
          selectMenu
        ) : (
          <div>
            <Hidden smDown>
              {Object.values(taskTypes).map(taskType => {
                const a2p10dlcDisabled =
                  taskType.name === 'trigger.cmd.send.sms' &&
                  !this.props.approvedCampaignExists

                const selectedActionButton = (
                  <SelectedActionButton
                    disabled={disabled || a2p10dlcDisabled}
                    key={`selectedActionButton${taskType.id}`}
                    Icon={
                      <EntityTypeIcon
                        entityType="task"
                        entityID={taskType.id}
                        className={classes.button}
                      />
                    }
                    actionType={taskTypeIDToNameMap?.[taskType.id]?.name}
                    title={taskType.display_name}
                    style={{ marginRight: 10, marginBottom: 10 }}
                    fullWidth={false}
                    size="small"
                    selectedAction={selectedAction}
                    handleFieldChange={handleFieldChange}
                    stepperGoTo={stepperGoTo}
                    taskName={taskName}
                    stepper={stepper}
                  />
                )

                return a2p10dlcDisabled ? (
                  <ClickableTooltip
                    content={<TooltipContent />}
                    key={`selectedActionButton${taskType.id}-tooltip`}
                  >
                    {selectedActionButton}
                  </ClickableTooltip>
                ) : (
                  selectedActionButton
                )
              })}
            </Hidden>
            <Hidden mdUp>{selectMenu}</Hidden>
            {showErrorText() && (
              <FormHelperText error>{showErrorText()}</FormHelperText>
            )}
          </div>
        )
      }
    },
  ),
)
